import { render } from "./sel-checkbox.vue?vue&type=template&id=4f90a312"
import script from "./sel-checkbox.vue?vue&type=script&lang=js"
export * from "./sel-checkbox.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__